import React from 'react';

import {TargetBlank} from '../../common/util/links';
import {LLMProvider} from '../PagePanelComponents/Home/Browse3/pages/common/traceCodeSnippets';

const OpenAIProviderNote = () => (
  <p>
    In this example, we're using a generated OpenAI API key which you can{' '}
    <TargetBlank href="https://platform.openai.com/api-keys">
      find here
    </TargetBlank>
    .
    <br />
    Using another provider? We support all major{' '}
    <TargetBlank href="https://weave-docs.wandb.ai/guides/integrations/">
      clients and frameworks
    </TargetBlank>
    .
  </p>
);

const AnthropicProviderNote = () => (
  <p>
    In this example, we're using a generated Anthropic API key which you can{' '}
    <TargetBlank href="https://console.anthropic.com/settings/keys">
      find here
    </TargetBlank>
    .
    <br />
    Using another provider? We support all major{' '}
    <TargetBlank href="https://weave-docs.wandb.ai/guides/integrations/">
      clients and frameworks
    </TargetBlank>
    .
  </p>
);

const WandbProviderNote = () => (
  <p>
    In this example, we're using W&B Inference.{' '}
    <TargetBlank href="https://docs.wandb.ai/guides/inference/">
      Learn more
    </TargetBlank>{' '}
    about our inference API.
  </p>
);

/**
 * Get the appropriate provider note component for the given LLM provider.
 * Provider notes help users understand where to find API keys and what provider they're using.
 */
export const getProviderNoteComponent = (provider: LLMProvider) => {
  switch (provider) {
    case 'openai':
      return <OpenAIProviderNote />;
    case 'anthropic':
      return <AnthropicProviderNote />;
    case 'wandb-inference':
      return <WandbProviderNote />;
    default:
      return <OpenAIProviderNote />;
  }
};
